<script setup lang="ts">
import {
	RadioGroupIndicator,
	RadioGroupItem,
	type RadioGroupItemProps,
} from 'radix-vue'
import { Circle } from 'lucide-vue-next'
import { cn } from '@/lib/utils'

const props = defineProps<RadioGroupItemProps & { class?: string }>()
</script>

<template>
	<RadioGroupItem
		v-bind="props"
		:class="
			cn(
				'group flex aspect-square h-20px w-20px cursor-pointer items-center justify-center rounded-full border-2 border-n-950',
				'hover:border-o-500',
				'data-[state=checked]:border-o-500',
				'focus-visible:border-o-500 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#ffeed4bf]',
				'disabled:pointer-events-none disabled:cursor-not-allowed disabled:!border-n-300 disabled:bg-n-100 ',
				props.class,
			)
		"
	>
		<RadioGroupIndicator
			:class="
				cn(
					'flex items-center justify-center',
					'data-[state=checked]:text-o-500',
					'group-disabled:text-n-300',
					props.class,
				)
			"
		>
			<Circle class="h-12px w-12px fill-current text-current" />
		</RadioGroupIndicator>
	</RadioGroupItem>
</template>
